import { BLACK, LILAC_200, LILAC_300, LILAC_500, tokens, WHITE } from '@airtel/air-design-system';
import { Dimensions, StyleSheet } from 'react-native';
export var getTableHeaderStyles = theme => {
  return StyleSheet.create({
    headerContainer: {
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: theme == 'white' ? WHITE : LILAC_300,
      padding: tokens.spacing.SPACING_16,
      alignItems: 'center',
      flex: 1,
      flexShrink: 0
    },
    headerText: {
      marginRight: tokens.spacing.SPACING_8
    },
    headerIcon: {
      flexShrink: 0
    },
    backdrop: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      backgroundColor: BLACK,
      opacity: 0.35,
      zIndex: 0
    },
    dropdownContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%'
    },
    dropdown: {
      position: 'relative',
      backgroundColor: LILAC_200,
      paddingVertical: tokens.spacing.SPACING_8,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16,
      borderColor: LILAC_500,
      borderWidth: 1,
      width: 222,
      maxHeight: Dimensions.get('window').height * 0.8,
      zIndex: 1
    },
    dropdownItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingVertical: tokens.spacing.SPACING_8,
      justifyContent: 'space-between'
    },
    clearBtn: {
      marginLeft: tokens.spacing.SPACING_4
    },
    button: {
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingVertical: tokens.spacing.SPACING_8
    }
  });
};